import React, {useRef} from 'react';
import {Button, Space, Tag, message} from 'antd';
import {EditOutlined, DeleteOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import SearchTable from '../../components/admin/SearchTable';
import StatusTag from '../../components/admin/StatusTag';
import {useConfirmModal} from '../../components/ConfirmModal';
import ENDPOINTS from '../../constants/endpoints';
import {ROUTES, formatPath} from '../../constants/PathRoutes';
import api from '../../services/api';
import {moneyMask} from "../../utils/utils";

export default function AdminProductList() {
    const navigate = useNavigate();
    const tableRef = useRef();
    const {showConfirm, ConfirmModal} = useConfirmModal();

    const handleDelete = async (id) => {
        showConfirm({
            title: 'Excluir Produto',
            description: 'Tem certeza que deseja excluir este produto?',
            type: 'danger',
            confirmText: 'Excluir',
            cancelText: 'Cancelar',
            onConfirm: async () => {
                try {
                    await api.delete(formatPath(ENDPOINTS.ECOMMERCE_PRODUCT_DETAIL, {id}));
                    message.success('Produto excluído com sucesso');
                    tableRef.current?.refetch();
                } catch (error) {
                    message.error('Erro ao excluir produto');
                }
            }
        });
    };

    const columns = [
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Categoria',
            dataIndex: 'category_name',
            key: 'category_name',
        },
        {
            title: 'Preço',
            dataIndex: 'price',
            key: 'price',
            width: 120,
            render: (price) => `R$ ${moneyMask(price)}`,
        },
        {
            title: 'Status',
            dataIndex: 'is_active',
            key: 'is_active',
            width: 100,
            render: (isActive) => <StatusTag isActive={isActive} />,
        },
        {
            title: 'Receita',
            dataIndex: 'requires_prescription',
            key: 'requires_prescription',
            width: 120,
            render: (requires) => (
                <Tag color={requires ? 'orange' : 'default'}>
                    {requires ? 'Obrigatória' : 'Não'}
                </Tag>
            ),
        },
        {
            title: 'Ações',
            key: 'actions',
            width: 150,
            render: (_, record) => (
                <Space>
                    <Button
                        type="primary"
                        icon={<EditOutlined/>}
                        size="small"
                        onClick={() => navigate(formatPath(ROUTES.ADMIN_ECOMMERCE_PRODUCT_EDIT, {id: record.id}))}
                    />
                    <Button
                        danger
                        icon={<DeleteOutlined/>}
                        size="small"
                        onClick={() => handleDelete(record.id)}
                    />
                </Space>
            ),
        },
    ];

    return (
        <>
            <SearchTable
                ref={tableRef}
                url={ENDPOINTS.ECOMMERCE_PRODUCT_LIST}
                columns={columns}
                title="Gerenciamento de Produtos"
                buttonProps={{
                    onClick: () => navigate(ROUTES.ADMIN_ECOMMERCE_PRODUCT_CREATE),
                    label: 'Novo Produto',
                }}
            />
            <ConfirmModal />
        </>
    );
}
